import type { RootState } from "~/store";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { type RecordShrinkEventDataInput, type RemoveShrinkEventDataInput } from "~/gql/graphqlBase.generated";

export type ShrinkReplayOperationKind = "record" | "remove";
export type ShrinkReplayOutcome = "failed" | "success";

export interface ShrinkReplayEvent {
	kind: ShrinkReplayOperationKind;
	outcome: ShrinkReplayOutcome;
	shrinkEventId?: string;
}

export interface RescuedShrinkRecordOperation {
	id: string;
	input: RecordShrinkEventDataInput;
	queuedAt: string;
	type: "record";
}

export interface RescuedShrinkRemoveOperation {
	id: string;
	input: RemoveShrinkEventDataInput;
	queuedAt: string;
	type: "remove";
}

export type RescuedLegacyShrinkOperation = RescuedShrinkRecordOperation | RescuedShrinkRemoveOperation;

export interface ShrinkMobileState {
	lastReplayEvent: ShrinkReplayEvent | null;
	pendingRescue: RescuedLegacyShrinkOperation[];
}

const initialState: ShrinkMobileState = {
	lastReplayEvent: null,
	pendingRescue: []
};

export const shrinkMobileSlice = createSlice({
	initialState,
	name: "shrinkMobile",
	reducers: {
		clearRescuedShrinkOperation: (state, action: PayloadAction<string>) => {
			state.pendingRescue = state.pendingRescue.filter((operation) => operation.id !== action.payload);
		},
		clearShrinkReplayEvent: (state) => {
			state.lastReplayEvent = null;
		},
		recordShrinkReplayEvent: (state, action: PayloadAction<ShrinkReplayEvent>) => {
			state.lastReplayEvent = action.payload;
		}
	}
});

export const { clearRescuedShrinkOperation, clearShrinkReplayEvent, recordShrinkReplayEvent } =
	shrinkMobileSlice.actions;

export const selectPendingRescueShrinkOperations = (state: RootState): RescuedLegacyShrinkOperation[] =>
	state.shrinkMobile.pendingRescue;

export const selectShrinkLastReplayEvent = (state: RootState): ShrinkReplayEvent | null =>
	state.shrinkMobile.lastReplayEvent;

export default shrinkMobileSlice.reducer;
